import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UploadViewerComponent } from 'src/app/components/upload-viewer/upload-viewer.component';
import { IFile } from 'src/app/interface/IFilesManager';

@Component({
    selector: 'app-files-manager',
    templateUrl: './files-manager.component.html',
    styleUrls: ['./files-manager.component.scss']
})
export class FilesManagerComponent {
    pdfUrl: SafeResourceUrl | null = null;

    @Input() files: IFile[] = [];
    @Input() isFileUploading = false;
    @Output() uploadFileEvent = new EventEmitter<{ base64Content: string; fileName: string }>();
    @Output() deleteFileEvent = new EventEmitter<IFile>();

    constructor(private sanitizer: DomSanitizer, private dialog: MatDialog) { }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            const file = input.files[0]; // Get the selected file

            this.convertToBase64(file).then(base64Content => {
                this.emitFileData({ base64Content, fileName: file.name });
            });
        }
    }

    convertToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64WithPrefix = reader.result as string;
                const base64 = base64WithPrefix.split(',')[1]; // Elimina el "data:...;base64,"

                resolve(base64);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    }

    seePDF(url: string) {
        const secureUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

        this.dialog.open(UploadViewerComponent, {
            data: { pdfUrl: secureUrl },
            width: '80%'
        });
    }

    emitFileData(fileData: { base64Content: string; fileName: string }) {
        this.uploadFileEvent.emit(fileData);
    }

    deleteFile(file: IFile) {
        this.deleteFileEvent.emit(file);
    }
}
